import styled from '@emotion/styled';

import StarFillIcon from '../../Icons/StarFillIcon';

interface TableStarRattingFormatterProps {
  data?: Record<string, any>;
  dataKey?: string;
  className?: string;
}

const TableStarRattingFormatter: React.FC<TableStarRattingFormatterProps> = ({
  data,
  dataKey,
  className,
}) => {
  const label = data && data[dataKey ?? ''];
  return (
    <Container className={className}>
      <StarFillIcon /> {label ?? 0}
    </Container>
  );
};

export default TableStarRattingFormatter;

const Container = styled.div`
  word-break: break-word;
  width: 100%;

  display: grid;
  grid-template-columns: 13px auto;
  gap: 4px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  align-items: center;
`;
